// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ZUGz","inputWrap":"Table_inputWrap__XSQkd","col":"Table_col__2lPsD","bmiTooltip":"Table_bmiTooltip__2Vy8k"};